import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import './UserMenu.css';

const UserMenu = ({ user, onSignOut }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="user-menu-container" ref={menuRef}>
            <button 
                className="user-menu-trigger" 
                onClick={() => setIsOpen(!isOpen)}
            >
                {user && user.photoURL ? (
                    <img 
                        src={user.photoURL} 
                        alt="Profile" 
                        className="profile-pic"
                    />
                ) : (
                    <FaUserCircle className="user-icon" />
                )}
            </button>

            {isOpen && (
                <div className="user-menu-dropdown">
                    {user ? (
                        <>
                            <div className="user-info-header">
                                <FaUserCircle className="user-icon-large" />
                                <span>{user.email}</span>
                            </div>
                            <div className="menu-divider" />
                            <button onClick={onSignOut}>Sign Out</button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => navigate('/login')}>Login</button>
                            <button onClick={() => navigate('/signup')}>Sign Up</button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default UserMenu; 